import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "../../controls/DashboardLayout";
import DashboardNavbar from "../../controls/DashboardNavbar";
import MDBox from "../../controls/MDBox";
import { Grid, Switch, FormControlLabel } from "@mui/material";
import { Card } from "react-bootstrap";
import MDTypography from "../../controls/MDTypography";
import MDButton from "../../controls/MDButton";
import DataTable from "../../controls/Tables/DataTable";
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import { postData, pathData, deleteData } from "../../Utils/Http/api";
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { CheckCircle, Cancel } from '@mui/icons-material';

// Configuraciones Casos Cualitativos → Tipos de Evento (tabla propia). Cada tipo lleva el caso a un estado de
// "Estados de la Gestión" de casos cualitativos.
function CasoCualitativoEventoTipoListar() {
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [descripcion, setDescripcion] = useState("");
    const [observaciones, setObservaciones] = useState("");
    const [activo, setActivo] = useState(true);
    const [enviaMail, setEnviaMail] = useState(false);
    const [estados, setEstados] = useState([]);
    const [selectedEstado, setSelectedEstado] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, msg: '', severity: 'success' });
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const fetchEstados = async () => {
        try {
            const res = await postData('/CasoCualitativoEstadoListar', {});
            setEstados((res?.value || []).map(e => ({ id: e.idCasoEstado, label: e.descripcion })));
        } catch (ex) {
            console.error('Error cargando estados', ex);
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await postData('/CasoCualitativoEventoTipoListar', {});
            const list = res?.value || [];
            const data = list.map(item => {
                const estado = estados.find(e => e.id === item.idCasoEstado);
                const canModify = item.sistema !== 1;

                const detalle = (
                    <MDBox>
                        <MDTypography variant="h6" color="text" fontWeight="medium">
                            {item.descripcion}
                        </MDTypography>
                        <MDTypography variant="caption" color="info" fontWeight="medium" display="block">
                            Estado: {item.idCasoEstado === 0 ? 'No cambia el estado' : (estado?.label || 'N/A')}
                        </MDTypography>
                        {!canModify && (
                            <MDTypography variant="caption" color="secondary" fontWeight="medium" display="block">
                                Tipo de sistema
                            </MDTypography>
                        )}
                        {item.observaciones && (
                            <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                                {item.observaciones}
                            </MDTypography>
                        )}
                    </MDBox>
                );

                const indicador = (activa, textoSi, textoNo, colorSi) => (
                    <MDBox display="flex" alignItems="center" gap={1}>
                        {activa ? (
                            <>
                                <CheckCircle sx={{ color: `${colorSi}.main`, fontSize: 18 }} />
                                <MDTypography variant="caption" color={colorSi} fontWeight="medium">{textoSi}</MDTypography>
                            </>
                        ) : (
                            <>
                                <Cancel sx={{ color: 'secondary.main', fontSize: 18 }} />
                                <MDTypography variant="caption" color="secondary" fontWeight="medium">{textoNo}</MDTypography>
                            </>
                        )}
                    </MDBox>
                );
                const statusInfo = (
                    <MDBox display="flex" flexDirection="column" gap={1}>
                        {indicador(item.activo === 1, 'Activo', 'Inactivo', 'success')}
                        {indicador(item.enviaMail === 1, 'Envía Mail', 'No Envía Mail', 'info')}
                    </MDBox>
                );

                const action = (
                    <MDBox display="flex" gap={1} alignItems="center" justifyContent="center">
                        {canModify && (
                            <>
                                <IconButton size="small" onClick={() => handleOpenEdit(item)} aria-label="editar">
                                    <EditIcon color="info" />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    onClick={() => { setDeleteId(item.idCasoEventoTipo); setOpenDelete(true); }}
                                    aria-label="eliminar"
                                >
                                    <DeleteIcon color="error" />
                                </IconButton>
                            </>
                        )}
                    </MDBox>
                );

                return { id: item.idCasoEventoTipo, detalle, statusInfo, action };
            });

            setRows(data);
            setColumns([
                { Header: 'Tipo de Evento', accessor: 'detalle', align: 'left', width: '50%' },
                { Header: 'Estado', accessor: 'statusInfo', align: 'left', width: '30%' },
                { Header: 'Acciones', accessor: 'action', align: 'center', width: '20%' }
            ]);
        } catch (ex) {
            console.error('Error cargando tipos de evento', ex);
            setSnackbar({ open: true, msg: 'Error al cargar los tipos de evento', severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEstados();
    }, [refreshKey]);

    useEffect(() => {
        if (estados.length > 0) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [estados, refreshKey]);

    const limpiarFormulario = () => {
        setCurrentItem(null);
        setDescripcion("");
        setObservaciones("");
        setActivo(true);
        setEnviaMail(false);
        setSelectedEstado(null);
    };

    const handleOpenAdd = () => {
        setEditMode(false);
        limpiarFormulario();
        setOpenDialog(true);
    };

    const handleOpenEdit = (item) => {
        setEditMode(true);
        setCurrentItem(item);
        setDescripcion(item.descripcion || "");
        setObservaciones(item.observaciones || "");
        setActivo(item.activo === 1);
        setEnviaMail(item.enviaMail === 1);
        setSelectedEstado(estados.find(e => e.id === item.idCasoEstado) || null);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        limpiarFormulario();
    };

    const handleSave = async () => {
        if (!descripcion.trim()) {
            setSnackbar({ open: true, msg: 'La descripción es requerida', severity: 'warning' });
            return;
        }
        if (!selectedEstado) {
            setSnackbar({ open: true, msg: 'Debe seleccionar un estado', severity: 'warning' });
            return;
        }
        try {
            const payload = {
                descripcion,
                idCasoEstado: selectedEstado.id,
                activo: activo ? 1 : 0,
                enviaMail: enviaMail ? 1 : 0,
                observaciones
            };
            const res = editMode
                ? await pathData(`/CasoCualitativoEventoTipoUpdate/${currentItem.idCasoEventoTipo}`, payload)
                : await postData('/CasoCualitativoEventoTipoRegistrar', payload);
            if (res?.isSuccess) {
                setSnackbar({ open: true, msg: editMode ? 'Tipo de evento actualizado correctamente' : 'Tipo de evento creado correctamente', severity: 'success' });
                handleCloseDialog();
                setRefreshKey(prev => prev + 1);
            } else {
                setSnackbar({ open: true, msg: res?.error || 'Error guardando tipo de evento', severity: 'error' });
            }
        } catch (ex) {
            console.error('Error guardando tipo de evento', ex);
            setSnackbar({ open: true, msg: ex?.detail || ex?.message || 'Error guardando tipo de evento', severity: 'error' });
        }
    };

    const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

    const handleCancelDelete = () => {
        setDeleteId(null);
        setOpenDelete(false);
    };

    const handleConfirmDelete = async () => {
        if (!deleteId) return;
        try {
            const res = await deleteData(`/CasoCualitativoEventoTipoDelete/${deleteId}`);
            if (res?.isSuccess) {
                setSnackbar({ open: true, msg: 'Tipo de evento eliminado correctamente', severity: 'success' });
                setOpenDelete(false);
                setDeleteId(null);
                setRefreshKey(prev => prev + 1);
            } else {
                setSnackbar({ open: true, msg: res?.error || 'Error eliminando tipo de evento', severity: 'error' });
            }
        } catch (ex) {
            console.error('Error eliminando tipo de evento', ex);
            setSnackbar({ open: true, msg: ex?.detail || ex?.message || 'Error eliminando tipo de evento', severity: 'error' });
            setOpenDelete(false);
            setDeleteId(null);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="secondary"
                                borderRadius="lg"
                                coloredShadow="secondary"
                            >
                                <MDTypography variant="h6" color="white">
                                    Tipos de Evento de Gestion Cualitativa
                                </MDTypography>
                            </MDBox>

                            <MDBox pt={3} py={3} px={2}>
                                <MDBox mb={2} display="flex" gap={1}>
                                    <MDButton onClick={handleOpenAdd} variant="gradient" color="success" startIcon={<AddIcon />}>
                                        Agregar Tipo de Evento
                                    </MDButton>
                                    <MDButton onClick={() => setRefreshKey(prev => prev + 1)} variant="outlined" color="info" startIcon={<SearchIcon />}>
                                        Buscar
                                    </MDButton>
                                </MDBox>

                                {loading ? (
                                    <MDBox display="flex" justifyContent="center" alignItems="center" py={6}>
                                        <CircularProgress />
                                    </MDBox>
                                ) : (
                                    <DataTable
                                        key={refreshKey}
                                        table={{ columns, rows }}
                                        isSorted={false}
                                        showTotalEntries
                                        canSearch={false}
                                        noEndBorder
                                        pagination={{ color: 'success', variant: 'gradient' }}
                                    />
                                )}

                                <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
                                    <DialogTitle>{editMode ? 'Editar Tipo de Evento' : 'Agregar Tipo de Evento'}</DialogTitle>
                                    <DialogContent>
                                        <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
                                            <TextField
                                                label="Descripción *"
                                                value={descripcion}
                                                onChange={(e) => setDescripcion(e.target.value)}
                                                inputProps={{ maxLength: 250 }}
                                                fullWidth
                                                required
                                            />
                                            <Autocomplete
                                                options={estados}
                                                getOptionLabel={(option) => option.label || ""}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                value={selectedEstado}
                                                onChange={(e, newValue) => setSelectedEstado(newValue)}
                                                renderInput={(params) => <TextField {...params} label="Estado al que lleva el caso *" />}
                                            />
                                            <TextField
                                                label="Observaciones"
                                                value={observaciones}
                                                onChange={(e) => setObservaciones(e.target.value)}
                                                inputProps={{ maxLength: 500 }}
                                                fullWidth
                                                multiline
                                                rows={3}
                                            />
                                            <MDBox display="flex" gap={3}>
                                                <FormControlLabel
                                                    control={<Switch checked={activo} onChange={(e) => setActivo(e.target.checked)} color="success" />}
                                                    label="Activo"
                                                />
                                                <FormControlLabel
                                                    control={<Switch checked={enviaMail} onChange={(e) => setEnviaMail(e.target.checked)} color="info" />}
                                                    label="Envía Mail"
                                                />
                                            </MDBox>
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCloseDialog}>Cancelar</MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleSave}>Guardar</MDButton>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth maxWidth="xs">
                                    <DialogTitle>Eliminar Tipo de Evento</DialogTitle>
                                    <DialogContent>
                                        <MDBox>
                                            <MDTypography>¿Confirma que desea eliminar este tipo de evento?</MDTypography>
                                        </MDBox>
                                    </DialogContent>
                                    <DialogActions>
                                        <MDButton variant="gradient" color="error" onClick={handleCancelDelete}>Cancelar</MDButton>
                                        <MDButton variant="gradient" color="info" onClick={handleConfirmDelete}>Eliminar</MDButton>
                                    </DialogActions>
                                </Dialog>

                                <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
                                    <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} elevation={6} variant="filled">
                                        {snackbar.msg}
                                    </MuiAlert>
                                </Snackbar>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default CasoCualitativoEventoTipoListar;
